module.exports = __webpack_public_path__ + "img/homeEsglogo.a6bb1bb.png";